import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './Navbar.css';
import logo from '../../assets/Saundarryam_Logo.png';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const { totalItems } = useCart();

  useEffect(() => {
    function handleClickOutside(e) {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <nav className="navbar" ref={navRef}>
      <div className="navbar__brand">
        <Link to="/" className="navbar__logo-link">
          <div className="navbar__logo-placeholder">
            <img src={logo} alt="Saundarryam Logo" />
          </div>
          <div className="navbar__brand-text">
            <span className="navbar__name">Saundarryam</span>
            <span className="navbar__tagline">Soaps</span>
          </div>
        </Link>
      </div>

      <div className="navbar__right">
        <Link to="/cart" className="navbar__cart-icon">
          🛒
          {totalItems > 0 && (
            <span className="navbar__cart-count">{totalItems}</span>
          )}
        </Link>

        <button
          className={`navbar__hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
        <li><NavLink to="/" end onClick={() => setMenuOpen(false)}>Home</NavLink></li>
        <li><NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink></li>
        <li><NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink></li>
        <li><NavLink to="/cart" onClick={() => setMenuOpen(false)}>
          Cart {totalItems > 0 && <span className="navbar__cart-count">{totalItems}</span>}
        </NavLink></li>
      </ul>
    </nav>
  );
}

export default Navbar;